import { render, staticRenderFns } from "./LiveExpiryDate.vue?vue&type=template&id=2656cae8&"
import script from "./LiveExpiryDate.vue?vue&type=script&lang=js&"
export * from "./LiveExpiryDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports